// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"199":"672b3f03","854":"02a9309c","915":"9e244f16"}[chunkId] + ".css";
};